import { render } from "./InvestBlock.vue?vue&type=template&id=2c4ca5b6&scoped=true"
import script from "./InvestBlock.vue?vue&type=script&lang=js"
export * from "./InvestBlock.vue?vue&type=script&lang=js"

import "./InvestBlock.vue?vue&type=style&index=0&id=2c4ca5b6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4ca5b6"]])

export default __exports__